<template>
  <div class="insight-renderer">
    <span v-for="(section, index) of populatedSection" :key="index">
      <span v-if="section.type === SectionNames.Text" class="text-section" :class="section.classes">
        {{ section.text }}
      </span>
      <span v-else-if="section.type === SectionNames.Amount" class="amount-section">
        {{ formatAmount(section.amount) }} ₪
      </span>
      <span v-else-if="section.type === SectionNames.Link" class="link-section" @click="openLink(section.url)">
        {{ section.text }}
      </span>
      <div class="line-break" :class="section.height" v-else-if="section.type === SectionNames.LineBreak"></div>
      <div v-else-if="section.type === SectionNames.Transactions" class="transactions-section">
        <div v-for="transaction in section.transactions" :key="transaction.transactionId" class="transaction">
          <div class="business-name">{{ transaction.businessName }}</div>
          <div class="transaction-amount">{{ formatAmount(transaction.amount) }} ₪</div>
        </div>
      </div>
      <transaction-table v-else-if="section.type === SectionNames.TransactionTable" :section="section"></transaction-table>
      <div v-else-if="section.type === SectionNames.BarGraph" class="bar-graph-container">
        <bar-graph :max-centered-bars="0" :spread-labels="true" :graph-height="102" :bar-values="section.data.bars" :with-sign="false"></bar-graph>
      </div>
      <insight-video-player v-else-if="section.type === SectionNames.VideoPlayer" :url="section.url"/>
    </span>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import moneyUtils from '../money';
import TransactionTable from './TransactionTable.vue';
import InsightVideoPlayer from './InsightVideoPlayer.vue';
import consts from '../consts';
import utils from './replace-variables';

export default {
  name: 'InsightBuilderRenderer',
  components: {
    TransactionTable,
    BarGraph: BaseUI.BarGraph,
    InsightVideoPlayer,
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
    insightData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    SectionNames() {
      return consts.SectionNames;
    },
    populatedSection() {
      return utils.replaceVariablesWithData(this.sections, this.insightData);
    },
  },
  methods: {
    formatAmount(amount) {
      return moneyUtils.formatAmountWithFraction(amount, 0);
    },
    openLink(url) {
      this.$emit('link-clicked', url);
    },
  },
};

</script>

<style lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.insight-renderer {
  .bold {
    font-weight: bold;
  }
  .title-line {
    font-weight: bold;
    display: block;
  }
  .amount-section {
    font-weight: bold;
    white-space: nowrap;
  }
  .link-section {
    text-decoration: underline;
    color: $riseup_blue;
    cursor: pointer;
  }
  .line-break {
    &.height-1 {
      height: 1em;
    }
    &.height-2 {
      height: 2em;
    }
  }
  .bar-graph-container {
    padding: 6px 20px;
    margin: 20px 0;
    border: 1px solid $riseup_gray_05;
    border-radius: 10px;
  }
  .transactions-section {
    padding: 6px 14px;
    margin: 12px 0;
    border-radius: 8px;
    background-color: $riseup_gray_0;
    .transaction {
      display: flex;
      font-size: 16px;
      line-height: 32px;

      .business-name {
        flex: 2 0 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .transaction-amount {
        flex: 1 0 0;
        text-align: left;
        margin-right: 15px;
        font-weight: bold;
      }
    }
  }
}
</style>
